export function initSlideContentOnJumpmark() {

    function openByHash() {
        const hash = window.location.hash;
        if (!hash) return;

        const targetHeading = document.querySelector(hash);
        if (!targetHeading) return;

        const item = targetHeading.closest('.slidecontentItem');
        const slidecontent = item?.closest('.slidecontent');
        if (!item || !slidecontent) return;

        slidecontent.querySelectorAll('.slidecontentItem').forEach(el => {
            el.classList.remove('is-active');
            const content = el.querySelector('.slidecontentItem__content');
            if (content) content.style.display = '';
        });

        item.classList.add('is-active');
        const content = item.querySelector('.slidecontentItem__content');
        if (content) content.style.display = 'block';

        targetHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        openByHash();
    } else {
        document.addEventListener('DOMContentLoaded', openByHash);
    }
    window.addEventListener('hashchange', openByHash);
}
